export const syncTags = (context) => (id, apply) => ({
    type: "CMS.INTEGRATIONS.SYNC_TAGS",
    payload: { id, apply },
    context,
});

export const updateConfiguration = (context) => (id) => ({
    type: "CMS.INTEGRATIONS.UPDATE_CONFIGURATION",
    payload: { id },
    context,
});
